<template>
  <BaseCard
    fullHeight
    :heading="filters.capitalize($t('register.invoice.details'))"
  >
    <Flex
      :gap="2"
      align="end"
    >
      <Flex direction="column">
        <Flex
          direction="column"
          :gap="0.5"
          fullHeight
        >
          <BaseHeading size="xs">
            {{ $t('register.invoice.sale_date') }}
          </BaseHeading>
          <BaseText v-test="'issue-invoice-sale-date'">
            {{ filters.date(saleDate, { format: 'longYear' }) }}
          </BaseText>
        </Flex>
        <Flex
          direction="column"
          :gap="0.5"
          fullHeight
        >
          <BaseHeading size="xs">
            {{ $t('register.invoice.issue_date') }}
          </BaseHeading>
          <BaseText v-test="'issue-invoice-issue-date'">
            {{ filters.date(issueDate, { format: 'longYear' }) }}
          </BaseText>
        </Flex>
        <BaseInput
          v-if="showDueDate"
          type="number"
          v-model="dueInDays"
          :label="$t('register.invoice.due_in')"
          :minValue="1"
          :maxValue="365"
          unitLabel="days"
          v-test="'issue-invoice-due-in-days'"
        />
      </Flex>
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { computed } from 'vue';
import dayjs from '@/dayjs';
import filters from '@/filters';

const props = defineProps<{
  invoicedAt: string;
  dueInDays: number;
  showDueDate?: boolean;
}>();

const emit = defineEmits<{
  'update:dueInDays': [number];
}>();

const saleDate = dayjs(props.invoicedAt).format('YYYY-MM-DD');
const issueDate = dayjs().format('YYYY-MM-DD');

const dueInDays = computed({
  get: () => props.dueInDays,
  set: (value: number) => emit('update:dueInDays', value),
});
</script>
